<template lang="pug">
.row
    .col-1
    .col-10
        h4.text-uppercase.text-center.my-5.ev-title {{ title }}
    .col-1
    .col-1
    .col-10.mb-3
        #calendar.mb-5
            .card(v-for='d in orderDates')
                #headingOne.card-header(:class='!detailed ? "text-sm-center" : ""')
                    h5.mb-0(v-if='detailed')
                        button.btn.btn-link.btn-block.text-left(data-toggle='collapse', :data-target='getCollapsId(d,true)', aria-expanded='false', :aria-controls='getCollapsId(d)')
                            .date.d-inline-block.d-column.align-items-center
                                .month {{ d.startsIn | month }}
                                .day.text-center.font-weight-bold {{ d.startsIn | day }}
                            h5.ml-3.d-inline-block.d-column.self-align-center.text-bold {{ d.name }}
                    h6.ml-3.d-inline-block.d-column.self-align-center.text-secondary.text-bold(v-else) {{ d.name }}
                .collapse(v-if='detailed' :id='getCollapsId(d)', aria-labelledby='headingOne', data-parent='#calendar')
                    .card-body(v-html='d.htmlDetail')
    .col-1

</template>

<script>
import EVENT from '@/constants/event-constants'
const monthLabels = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]

export default {
    props: {
        title: { type: String, required: true },
        detailed: { type: Boolean, default: true  },
        datesContent: { type: Array, required: true },
        order: { type: Number, default: EVENT.NOT_ORDER }
    },
    data () {
        return {
            dates: []
        }
    },
    filters: {
        day: function (date) {
            // let day = date.getDate()
            // return `${day < 10 ? '0' : ''}${day}`
            return date.getDate()
        },
        month: function (date) {
            return monthLabels[date.getMonth()]
        }
    },
    methods: {
        getCollapsId (dataObject, asRef=false) {        
            return `${asRef ? '#' : ''}collapse-${dataObject.id}`;
        }
    },
    computed: {
        orderDates () {
            if (this.order == EVENT.DES_ORDER) 
                return this.dates.sort( (d1, d2) =>  d2.startsIn - d1.startsIn )
            if (this.order == EVENT.ASC_ORDER) 
                return this.dates.sort( (d1, d2) =>  d1.startsIn - d2.startsIn )
            return this.dates
        }
    },
    beforeMount () {

        if (this.detailed) {
            let consecutivo = 0
            this.dates = this.datesContent.map( date => {
                let now = new Date()
                consecutivo++
                return Object.assign( {}, date, {
                    id: `${now.getSeconds()}${now.getMilliseconds()}${consecutivo}`
                })
            })
        } else {
            this.dates = this.datesContent
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/landing/events/Calendar.vue